// ----------------------------------------------------------------------

const shape = {
  borderRadius: 0,
  borderRadiusSm: 0,
  borderRadiusMd: 10
};

export default shape;
